import { Outlet } from 'react-router-dom';
import { Breadcrumbs } from '../components/common/Breadcrumbs';
import { FloatingButtons } from '../components/layout/FloatingButtons';
import { Footer } from '../components/layout/Footer';
import { Navbar } from '../components/layout/Navbar';
import { ScrollProgress } from '../components/layout/ScrollProgress';

export function AppLayout() {
  return (
    <>
      <ScrollProgress />
      <Navbar />
      <Breadcrumbs />
      <main>
        <Outlet />
      </main>
      <Footer />
      <FloatingButtons />
    </>
  );
}
